var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品分类：" } },
                    [
                      _c("el-cascader", {
                        staticClass: "selWidth ",
                        attrs: {
                          options: _vm.merCateList,
                          props: {
                            value: "id",
                            label: "name",
                            children: "child",
                            expandTrigger: "hover",
                            checkStrictly: true,
                          },
                          clearable: "",
                          "show-all-levels": false,
                          size: "small",
                        },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.listPram.categoryIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "categoryIds", $$v)
                          },
                          expression: "listPram.categoryIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "对应商品：", prop: "labelName" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth ",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择",
                            filterable: "",
                            "filter-method": _vm.handleProductSearch,
                          },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.skuId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "skuId", $$v)
                            },
                            expression: "listPram.skuId",
                          },
                        },
                        _vm._l(_vm.productLists, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.skuName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth ",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: {
                            change: function ($event) {
                              return _vm.handerSearch(0)
                            },
                          },
                          model: {
                            value: _vm.listPram.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "status", $$v)
                            },
                            expression: "listPram.status",
                          },
                        },
                        _vm._l(_vm.orderStateOption, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡密：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth ",
                          attrs: {
                            placeholder: "请输入",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.carmine,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "carmine", $$v)
                            },
                            expression: "listPram.carmine",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth ",
                          attrs: {
                            placeholder: "请输入",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.phone,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "phone", $$v)
                            },
                            expression: "listPram.phone",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "current-product-name" }, [
                _vm._v("当前卡券商品：" + _vm._s(_vm.productName || "--")),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-action-row" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handlerOpenEdit({ skuId: _vm.skuId })
                        },
                      },
                    },
                    [_vm._v("新增卡密")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.openImportDialog },
                    },
                    [_vm._v("导入卡密")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "兑换ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名",
                  "min-width": "200",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cardNo", label: "卡号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "carmine", label: "卡密" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dueTime",
                  label: "用户可购买有效期",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "发送手机号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "customer", label: "关联小程序" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "username", label: "下单用户" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {}, [
                        _vm._v(
                          _vm._s(
                            "ID:" +
                              (scope.row.uid || "--") +
                              " 昵称:" +
                              (scope.row.username || "--")
                          )
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        scope.row.status != "作废"
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeKami([scope.row.id])
                                  },
                                },
                              },
                              [_vm._v("作废")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditCard", {
        ref: "EditCardRef",
        on: { doRefresh: _vm.handlerGetListData },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "import-dialog",
          attrs: {
            title: "导入卡密",
            visible: _vm.importDialogVisible,
            width: "560px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
            closed: _vm.resetImportDialog,
          },
        },
        [
          _c(
            "div",
            { staticClass: "import-dialog-center" },
            [
              _c(
                "div",
                { staticClass: "template-row" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleDownloadTemplate },
                    },
                    [_vm._v("下载模板")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  ref: "importUpload",
                  staticClass: "upload-area",
                  attrs: {
                    drag: "",
                    action: "#",
                    "auto-upload": false,
                    "show-file-list": false,
                    "on-change": _vm.handleImportFileChange,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload upload-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _c("div", [_vm._v("点击或拖拽文件到此区域上传")]),
                    _vm._v(" "),
                    _c("div", [_vm._v("支持扩展名：.xlsx、.xls")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.importFileName
                ? _c(
                    "div",
                    { staticClass: "file-name" },
                    [
                      _c("div", { staticClass: "selected-file-info" }, [
                        _c("i", {
                          staticClass: "el-icon-success selected-file-icon",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "selected-file-text" }, [
                          _vm._v(_vm._s(_vm.importFileName)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "selected-file-remove",
                          attrs: { type: "text" },
                          on: { click: _vm.handleRemoveImportFile },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.importSubmitLoading },
                  on: {
                    click: function ($event) {
                      _vm.importDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.importSubmitLoading },
                  on: { click: _vm.handleConfirmImport },
                },
                [_vm._v("确定导入")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }